import type { DeliverySchoolRow } from '@/lib/api/drive';

/** Próg operacyjny „szkoła wymaga uwagi”. Jawny, konserwatywny, ten sam co po stronie backendu. */
export const PROBLEM_THRESHOLD_PCT = 80;
export const MIN_DELIVERIES = 5;

/**
 * Szkoły do zajęcia się w pierwszej kolejności.
 * Mała próba NIE trafia na listę — szkoła z dwiema dostawami i jedną wpadką nie jest problemem
 * operacyjnym, tylko szumem, a lista, która krzyczy o szumie, przestaje być czytana.
 */
export function problemSchoolsFrom(rows: readonly DeliverySchoolRow[]): DeliverySchoolRow[] {
  return rows
    .filter((r) => r.current.deliveries >= MIN_DELIVERIES)
    .filter((r) => r.data_quality !== 'MISSING_HISTORY')
    .filter((r) => r.current.on_time_pct !== null && r.current.on_time_pct < PROBLEM_THRESHOLD_PCT)
    .sort((a, b) => (a.current.on_time_pct ?? 100) - (b.current.on_time_pct ?? 100));
}
